import { NgModule } from '@angular/core';

import { SMART_EDIT_FEATURE, SmartEditRootModule } from '@spartacus/smartedit/root';
import { provideConfig } from '@spartacus/core';

@NgModule({
  imports: [
    SmartEditRootModule
  ],
  providers: [
    provideConfig({
      featureModules: {
        [SMART_EDIT_FEATURE]: {
          module: () => import('@spartacus/smartedit').then((m) => m.SmartEditModule)
        }
      },
      smartEdit: {
        storefrontPreviewRoute: 'cx-preview',
        allowOrigin:
          '*.brandsites.api.jfkls.net:443, ' +
          '*.*.brandsites.api.jfkls.net:443, ' +
          '*.brandsites.api.groupe-seb.com:443, ' +
          '*.brandsites.back.groupe-seb.com:443, ' +
          'brandsites.back.groupe-seb.com:443, ' +
          'backoffice.*.model-t.cc.commerce.ondemand.com:443'
      }
    })
  ]
})
export class SmartEditFeatureModule {}
